import { DashboardResponse } from '@com-delta-idp/mnx-sitewide-shared-core-smart';
import { DATA_ANALYTICS, USER_LOGGED_IN_STATUS } from '../models';
import {
  DataLayerAnalytics,
  PreviousPageDetails,
  User
} from '../models/analytics/analytics.interface';

export const getValidValue = (value: string): string => {
  return value ? value : '';
};

export const getCountry = (value: string): string => {
  return value ? value.substring(3, 5) : 'us';
};

export const getLanguage = (value: string): string => {
  return value ? value.substring(0, 2) : 'en';
};

export const isMobile = (): boolean =>
  /android|iphone|ipad|kindle/i.test(navigator.userAgent);

export const getSystemEnvironment = (): string =>
  isMobile() ? DATA_ANALYTICS.MOBILE : DATA_ANALYTICS.DESKTOP;

export const getPreviousPageDetails = (): PreviousPageDetails => {
  const pageURL = document.referrer;
  if (pageURL) {
    const previousPageURL = new URL(pageURL).pathname;
    const previousPageName = previousPageURL
      ? `dal${previousPageURL.split('/').join(':')}`
      : '';
    return {
      url: previousPageURL,
      name: previousPageName
    };
  } else {
    return {
      url: '',
      name: ''
    };
  }
};

export const getPageLoadTime = (pageLoadStartTime: number): number => {
  return pageLoadStartTime
    ? Number(((Date.now() - pageLoadStartTime) / 1000).toFixed(2))
    : 0;
};

export const getPageInfoDataForAnalytics = (
  analyticsData: DataLayerAnalytics,
  prefUI: string,
  pageLoadStart: number
): DataLayerAnalytics => {
  return {
    ...analyticsData,
    page: {
      ...analyticsData.page,
      info: {
        ...analyticsData.page.info,
        page_url: window.location.pathname,
        previous_page_name: getPreviousPageDetails().name,
        previous_page_url: getPreviousPageDetails().url,
        country: getCountry(prefUI),
        language: getLanguage(prefUI),
        sys_env: getSystemEnvironment(),
        page_load_time: getPageLoadTime(pageLoadStart)
      }
    }
  };
};

export const getUserDataForAnalytics = (
  analyticsData: DataLayerAnalytics,
  response: DashboardResponse
): User => {
  return {
    ...analyticsData.user,
    profile: {
      skymiles_number: getValidValue(response.smNumber),
      medalion_tier: getValidValue(response.membershipLevel),
      cobrand_type: getValidValue(response.smeCardTypes),
      available_miles: parseInt(getValidValue(response.smBalance)) || 0,
      encrypted_email: getValidValue(response.primaryEmailAddress),
      email_domain: getValidValue(
        response?.primaryEmailAddress?.split('@')?.[1]
      ),
      company_name: getValidValue(response.smeCompanyName)
    },
    attributes: {
      ...analyticsData.user.attributes,
      is_logged_in: USER_LOGGED_IN_STATUS.AUTHENTICATED,
      login_state: USER_LOGGED_IN_STATUS.HOT,
      login_method: getValidValue(response.userId)
    }
  };
};

export const getCookieValue = (cookieName: string) => {
  const result = new RegExp(
    '(?:^|; )' + encodeURIComponent(cookieName) + '=([^;]*)'
  ).exec(document.cookie);
  return result ? result[1] : false;
};

export const getLoggedInStatus = (): boolean => {
  const accountTypeCookie = getCookieValue(DATA_ANALYTICS.ACCOUNTTYPE);
  const accountCookie = getCookieValue(DATA_ANALYTICS.ACCOUNT);
  if (accountTypeCookie || accountCookie) {
    return true;
  }
  return false;
};
